<template>
    <div class="landingpage-middleware">
        <LandingPageEcommerce v-if="isEcommercePlatform"/>
        <LandingPage v-else/>
    </div>
</template>

<script>
import LandingPage from './LandingPage'
import LandingPageEcommerce from './Ecommerce/LandingPageEcommerce/index.vue'
import { mapGetters } from 'vuex'
export default {
    name: 'LandingPageMiddleware',
    components: {
        LandingPage,
        LandingPageEcommerce
    },
    computed: {
        ...mapGetters([
            'isEcommercePlatform'
        ]),
    }
}
</script>

<style>

</style>